import axios from "axios";
import { getLanguages, getToken, langDetection, validationSegment, downloadFile } from "../services/Connector";
import { fileSelectors } from "../reducers/uploadFileReducer";
import { updateSourceText } from "../reducers/translationReducer";
import { ConvertTagsToHtml, FindTagToInject, TagToHtml } from "../helpers/TagHelper";
import { HTMLToXLIF } from "../helpers/textCleanerHelper";
import { addSegments, segmentIsOpened, acceptTranslatedSegment } from "../reducers/segmentsReducer";
import Enumerable from "linq";
import { InsertHTMLOnCaretPosition } from "../helpers/TextSelectionHelpers";

export const Middleware = (api) => (next) => async (action) => {
  // console.log(action);
  // if (!sessionStorage.getItem("token")) {
  //   let sso = (window.location.href = "https://api.textunited.com/jsoneditor/auth/login?ReturnUrl=http://localhost:3000&checkOnly=N");
  //   let token = window.location.search;
  //   if (window.location.search) {
  //     let params = window.location.search.split("&");
  //     console.log(params);
  //     let testtoken = params[0];
  //     let refresh_token = params[1];
  //     console.log(refresh_token.substring(13, refresh_token.length));
  //     console.log(testtoken.substring(13, testtoken.length));
  //     sessionStorage.setItem("token", testtoken.substring(13, testtoken.length));
  //     sessionStorage.setItem("refresh_token", refresh_token.substring(13, refresh_token.length));
  //     window.location = "http://localhost:3000";
  //   }
  // }
  let store = api.getState();
  console.log(store);
  if (action.type !== undefined) {
    switch (action.type) {
      // case "laguages/fetchLanguagesGenerator": {
      //   api.dispatch(getLanguages());
      //   break;
      // }
      case "laguages/detectLanguageGenerator": {
        let a = action.payload;
        api.dispatch(langDetection(a));
        break;
      }
      case "uploadFile/uploadFileGenerator": {
        let a = action.payload;
        api.dispatch(getToken(a));
        break;
      }
      case "translationModel/generateUpdateSourceTextAction": {
        let a = action.payload;
        let transUnits = fileSelectors.selectAll(store);
        let st = transUnits.map(({ id, segmentText }) => ({
          segmentId: id,
          sourceText: segmentText,
        }));
        next(updateSourceText({ targetId: a, sourceText: st }));
        break;
      }
      case "segments/generateAddSegmentsAction": {
        let segmentsData = action.payload;
        const segm = [];
        for (let x in segmentsData.segments) {
          const source = ConvertTagsToHtml(segmentsData.segments[x].sourceText);

          const target = ConvertTagsToHtml(segmentsData.segments[x].targetText);

          let obj = {};

          obj.SourceId = segmentsData.segments[x].segmentId;
          obj.TargetId = segmentsData.segments[x].segmentId;
          obj.Source = segmentsData.segments[x].sourceText;
          obj.Target = segmentsData.segments[x].targetText;
          obj.SourceTextHtml = source.ResultHTML;
          obj.TargetTextHtml = target.ResultHTML;
          obj.SourcePlainText = source.PlainText;
          obj.TargetPlainText = target.PlainText;
          obj.SourceTags = target.Tags;
          obj.isOpened = false;

          segm.push(obj);
        }
        next(addSegments(segm));
        break;
      }

      case "segments/generateSegmentIsOpenAction": {
        let openedSegmentId = 0;
        let segmentToOpen = 0;
        let a = action.payload;
        let segments = Object.values(store.segments.entities);
        let openedSegments = segments.filter((x) => x.isOpened === true);
        if (openedSegments.length > 0 && openedSegments.TargetId !== a) {
          openedSegmentId = openedSegments[0].TargetId;
        }
        segmentToOpen = a;

        next(segmentIsOpened({ openedSegmentId, segmentToOpen }));
        break;
      }
      case "validationResult/generateSegmentValidation": {
        let a = action.payload;
        let segments = Object.values(store.segments.entities); //.find((x) => x.TargetId === a.id);
        // let segment = Enumerable.from(segments)
        //   .where((x) => x.TargetId === a.id)
        //   .first();
        let segment = Enumerable.from(segments).firstOrDefault((x) => x.TargetId === a.id);
        let clearTargetFromHtml = HTMLToXLIF(a.text);
        let clearSourceFromHtml = HTMLToXLIF(segment.SourceTextHtml);
        let segmentData = { SourceText: clearSourceFromHtml, TargetText: clearTargetFromHtml, segmentId: a.id };
        api.dispatch(validationSegment(segmentData));
        next(acceptTranslatedSegment({ id: a.id, text: a.text }));
        break;
      }
      case "segments/injectTagAction": {
        let a = action.payload;
        let segments = Object.values(store.segments.entities);
        let segment = Enumerable.from(segments).firstOrDefault((x) => x.TargetId === a);

        let segmentTags = segment.SourceTags;
        let tag = FindTagToInject(segmentTags);
        if (tag !== null) {
          let htmlTag = TagToHtml(tag);
          InsertHTMLOnCaretPosition(htmlTag);
          let target = document.getElementById("target" + a);
          if (target !== null) {
            target.focus();
          }
        }
        break;
      }
      case "uploadFile/downloadTranslatedFileGenerator": {
        let segments = Object.values(store.segments.entities);
        let fileId = store.uploadFile.fileId;
        let transUnits = [];
        for (let segment in segments) {
          let obj = {};
          let converted = HTMLToXLIF(segments[segment].TargetTextHtml);
          obj.id = segments[segment].TargetId;
          obj.segmentText = converted;

          transUnits.push(obj);
        }

        let requestModel = {
          fileId: fileId,
          transUnits: transUnits,
        };
        api.dispatch(downloadFile(requestModel));
      }
    }
  }
  return next(action);
};
